import { render, staticRenderFns } from "./heatmap-switch.vue?vue&type=template&id=2ce91b1e&scoped=true&"
import script from "./heatmap-switch.vue?vue&type=script&lang=js&"
export * from "./heatmap-switch.vue?vue&type=script&lang=js&"
import style0 from "./heatmap-switch.vue?vue&type=style&index=0&id=2ce91b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce91b1e",
  null
  
)

export default component.exports